module.exports = __webpack_public_path__ + "img/SDH.png";